import type { ButtonHTMLAttributes } from "react";
import { buttonClass, type ButtonSize, type ButtonVariant } from "@client/lib/buttonStyles";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export function Button({
  variant = "primary",
  size = "md",
  className = "",
  type = "button",
  ...props
}: ButtonProps) {
  // `type` defaults to "button": an unmarked button inside a form submits it,
  // which is how a "Remove row" control ends up saving the page.
  return <button type={type} className={`${buttonClass(variant, size)} ${className}`} {...props} />;
}
